import { lazy } from 'react';

import { ALLOWED_ROLES } from '@src/packages/utils';

import { PATHS } from './constants';

const TriggersList = lazy(() => import('./screens/TriggersList'));
const Trigger = lazy(() => import('./screens/Trigger'));

const routesRoutes = [
  {
    component: TriggersList,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.TRIGGERS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Trigger,
    path: PATHS.CREATE_TRIGGER,
    overlay: true,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.TRIGGERS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Trigger,
    path: PATHS.EDIT_TRIGGER,
    overlay: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.TRIGGERS.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
